import { render, staticRenderFns } from "./document-form.vue?vue&type=template&id=7f91f118&scoped=true&"
import script from "./document-form.vue?vue&type=script&lang=js&"
export * from "./document-form.vue?vue&type=script&lang=js&"
import style0 from "./document-form.vue?vue&type=style&index=0&id=7f91f118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f91f118",
  null
  
)

export default component.exports